import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Zap, Lock, ShieldCheck, CreditCard, Building2, ArrowRight } from 'lucide-react';
export const CheckoutSection = () => {
  const checkoutLinks = {
    base: 'https://biologiafemenina.com.ar/checkouts/cn/hWNBKvOnTUfusXpsS1YO6YXi/es-ar?_r=AQABDsr1GyZIz6f_sHMBHrqqdfFB4Oxio3m1G6Tg7UY8QyU',
    bundle: 'https://biologiafemenina.com.ar/checkouts/cn/hWNBKvV1Kneoqw2AnYZRN85K/es-ar?_r=AQABy74pp7ymH84llco8z9SCF99UOhwqcHrLaueRUfAtSt8'
  };
  const [selected, setSelected] = useState<'base' | 'bundle'>('base');
  const [time, setTime] = useState({
    h: 23,
    m: 54,
    s: 41
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        let {
          h,
          m,
          s
        } = prev;
        s--;
        if (s < 0) {
          s = 59;
          m--;
        }
        if (m < 0) {
          m = 59;
          h--;
        }
        if (h < 0) {
          h = 23;
          m = 59;
          s = 59;
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <section id="checkout" className="scroll-mt-10" data-id="element-13">
      {/* Countdown Timer Bar */}
      <div className="bg-coral-500 py-3 px-4 flex items-center justify-center gap-3 text-white font-bold text-sm sm:text-base tracking-wide" data-id="element-14">
        <Zap size={18} className="text-yellow-300" fill="currentColor" data-id="element-15" />
        <span data-id="element-16">OFERTA EXPIRA EN:</span>
        <div className="flex items-center gap-1" data-id="element-17">
          <span className="bg-dark text-white px-2 py-1 rounded-md font-black text-lg sm:text-xl" data-id="element-18">
            {pad(time.h)}
          </span>
          <span data-id="element-19">h :</span>
          <span className="bg-dark text-white px-2 py-1 rounded-md font-black text-lg sm:text-xl" data-id="element-20">
            {pad(time.m)}
          </span>
          <span data-id="element-21">m :</span>
          <span className="bg-dark text-white px-2 py-1 rounded-md font-black text-lg sm:text-xl" data-id="element-22">
            {pad(time.s)}
          </span>
          <span data-id="element-23">s</span>
        </div>
      </div>

      {/* Main Checkout Area */}
      <div className="bg-dark py-16 sm:py-20 px-4 sm:px-6 lg:px-8" data-id="element-24">
        <div className="max-w-xl mx-auto" data-id="element-25">
          {/* Heading */}
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl sm:text-3xl font-black text-white text-center mb-8 leading-tight" data-id="element-26">
            Tu mente no está fallada. Solo necesitaba el sistema correcto.
          </motion.h2>

          <p className="text-gray-400 text-center mb-6 text-sm sm:text-base" data-id="element-27">
            Elegí tu plan:
          </p>

          {/* Order Bump 1: Sistema Base */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} onClick={() => setSelected('base')} className={`rounded-2xl p-4 sm:p-5 mb-4 cursor-pointer transition-all duration-200 border-2 ${selected === 'base' ? 'border-coral-500 bg-white/5' : 'border-white/10 bg-white/[0.02] hover:bg-white/5'}`} data-id="element-28">
            <div className="flex items-start gap-3 sm:gap-4" data-id="element-29">
              {/* Radio */}
              <div className={`mt-1 w-5 h-5 rounded-full border-2 shrink-0 flex items-center justify-center ${selected === 'base' ? 'border-coral-500' : 'border-gray-500'}`} data-id="element-30">
                {selected === 'base' && <div className="w-2.5 h-2.5 rounded-full bg-coral-500" data-id="element-31" />}
              </div>

              {/* Content */}
              <div className="flex-1" data-id="element-32">
                <div className="flex items-center gap-2 mb-1" data-id="element-33">
                  <span className="text-gold-400 text-xs font-bold uppercase tracking-wider" data-id="element-34">
                    ⭐ SISTEMA ORIGINAL
                  </span>
                </div>
                <h3 className="text-white font-black text-lg sm:text-xl" data-id="element-35">
                  Reset de Dopamina
                </h3>
                <p className="text-gray-400 text-sm mt-1" data-id="element-36">6 Tomos + 3 Bonus</p>
              </div>

              {/* Price */}
              <div className="text-right shrink-0 ml-2" data-id="element-37">
                <p className="text-gray-500 line-through text-sm" data-id="element-38">$39.990</p>
                <p className="text-coral-500 font-black text-2xl sm:text-3xl" data-id="element-39">
                  $19.990
                </p>
              </div>
            </div>
          </motion.div>

          {/* Order Bump 2: Bundle Completo */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} onClick={() => setSelected('bundle')} className={`rounded-2xl overflow-hidden mb-8 cursor-pointer transition-all duration-200 border-2 ${selected === 'bundle' ? 'border-coral-500 bg-white/5' : 'border-white/10 bg-white/[0.02] hover:bg-white/5'}`} data-id="element-40">
            {/* Best option banner */}
            <div className="bg-white/10 py-2 px-4 text-center" data-id="element-41">
              <span className="text-gold-400 text-xs sm:text-sm font-bold tracking-wider uppercase" data-id="element-42">
                🏆 LA MEJOR OPCIÓN PARA NO FALLAR
              </span>
            </div>

            <div className="p-4 sm:p-5" data-id="element-43">
              <div className="flex items-start gap-3 sm:gap-4" data-id="element-44">
                {/* Radio */}
                <div className={`mt-1 w-5 h-5 rounded-full border-2 shrink-0 flex items-center justify-center ${selected === 'bundle' ? 'border-coral-500' : 'border-gray-500'}`} data-id="element-45">
                  {selected === 'bundle' && <div className="w-2.5 h-2.5 rounded-full bg-coral-500" data-id="element-46" />}
                </div>

                {/* Content */}
                <div className="flex-1" data-id="element-47">
                  <div className="flex items-center gap-2 mb-1" data-id="element-48">
                    <span className="text-gold-400 text-xs font-bold uppercase tracking-wider" data-id="element-49">
                      👑 PACK ELITE
                    </span>
                  </div>
                  <h3 className="text-white font-black text-lg sm:text-xl" data-id="element-50">
                    Paquete Completo 💎
                  </h3>
                  <p className="text-gray-400 text-sm mt-1" data-id="element-51">
                    6 tomos + 3 bonus + Agenda de Micro-Dosis + Freno de
                    Emergencia
                  </p>
                </div>

                {/* Price */}
                <div className="text-right shrink-0 ml-2" data-id="element-52">
                  <p className="text-gray-500 line-through text-sm" data-id="element-53">$59.990</p>
                  <p className="text-coral-500 font-black text-2xl sm:text-3xl" data-id="element-54">
                    $29.990
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* CTA Button */}
          <motion.a href={checkoutLinks[selected]} target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="block w-full py-5 px-6 text-center rounded-2xl font-black text-lg sm:text-xl text-white bg-coral-500 hover:bg-coral-600 hover:scale-[1.02] transition-all shadow-xl shadow-coral-500/20 mb-6" data-id="element-55">
            <span className="flex items-center justify-center gap-2" data-id="element-56">
              🌟 QUIERO EL PAQUETE COMPLETO
            </span>
            <span className="block text-sm font-medium text-white/70 mt-1" data-id="element-57">
              {selected === 'base' ? '$19.990' : '$29.990'} · Acceso Inmediato
            </span>
          </motion.a>

          {/* Description */}
          <div className="bg-white/5 rounded-xl p-4 sm:p-5 mb-6 border border-white/10" data-id="element-58">
            <p className="text-gray-300 text-sm sm:text-base leading-relaxed break-words" data-id="element-59">
              {'6 Tomos + 3 Bonus + 2 Ebooks Elite: Agenda de Micro-Dosis y Freno de Emergencia. El pack completo para resultados diarios visibles y medibles.'}
            </p>
          </div>

          {/* Payment Methods */}
          <div className="flex items-center justify-center gap-3 sm:gap-6 text-gray-400 text-xs sm:text-sm mb-6" data-id="element-60">
            <span className="flex items-center gap-1.5" data-id="element-61">
              <CreditCard size={16} data-id="element-62" /> Tarjetas
            </span>
            <span className="text-gray-600" data-id="element-63">·</span>
            <span className="flex items-center gap-1.5" data-id="element-64">
              <Building2 size={16} data-id="element-65" /> Transferencia
            </span>
            <span className="text-gray-600" data-id="element-66">·</span>
            <span className="flex items-center gap-1.5" data-id="element-67">
              <Lock size={16} data-id="element-68" /> Mercado Pago
            </span>
          </div>

          {/* Security Badge */}
          <div className="bg-white/5 rounded-xl p-4 flex items-start gap-3 border border-white/10" data-id="element-69">
            <ShieldCheck size={24} className="text-blue-400 shrink-0 mt-0.5" data-id="element-70" />
            <p className="text-gray-300 text-sm" data-id="element-71">
              <span className="font-bold text-white" data-id="element-72">Compra 100% segura</span> ·
              Datos protegidos · Acceso inmediato · 🇦🇷 Argentina
            </p>
          </div>
        </div>
      </div>
    </section>;
};